export enum ContentStateRestrictionLevel {
	NONE = 'NONE',
	PAGE_OWNER = 'PAGE_OWNER',
}
